import { Injectable } from '@angular/core';
import {
  ProductFormDraftSnapshot,
  ProductFormDraftSummary,
} from '@features/catalog/models/product-form-draft.models';
import {
  buildProductFormDraftSnapshot,
  BuildProductFormDraftSnapshotInput,
  normalizeDraftFormValue,
} from '@features/catalog/utils/product-form-draft.utils';
import {
  isProductFormDraftStorageAvailable,
  readProductFormDraftSummaries,
  readProductFormDraftSnapshot,
  removeProductFormDraft,
  writeProductFormDraft,
} from '@features/catalog/presentation/utils/product-form-draft.storage';

@Injectable()
export class ProductFormDraftCoordinatorService {
  isStorageAvailable(storage?: Storage | null): boolean {
    return isProductFormDraftStorageAvailable(storage);
  }

  createDraftKey(isEdit: boolean, productId: string | null, createTempId: () => string): string {
    return isEdit && productId
      ? `catalog.product-form.edit.${productId}`
      : `catalog.product-form.new.${createTempId()}`;
  }

  listRecoveryCandidates(
    isEdit: boolean,
    productId: string | null,
    storage: Storage = window.localStorage
  ): ProductFormDraftSummary[] {
    const summaries = readProductFormDraftSummaries(storage);
    if (isEdit && productId) {
      return summaries.filter((draft) => draft.mode === 'edit' && draft.productId === productId);
    }
    return summaries.filter((draft) => draft.mode === 'new');
  }

  readSnapshot(key: string, storage: Storage = window.localStorage): ProductFormDraftSnapshot | null {
    return readProductFormDraftSnapshot(key, storage);
  }

  buildSnapshot(input: BuildProductFormDraftSnapshotInput): ProductFormDraftSnapshot {
    return buildProductFormDraftSnapshot(input);
  }

  normalizeFormValue(
    formValue: ProductFormDraftSnapshot['formValue'] & {
      sendToKitchen?: boolean;
      primaryCategoryId?: string | null;
    }
  ): ProductFormDraftSnapshot['formValue'] {
    return normalizeDraftFormValue(formValue);
  }

  persistSnapshot(key: string, snapshot: ProductFormDraftSnapshot, storage: Storage = window.localStorage): void {
    try {
      writeProductFormDraft(key, snapshot, storage);
    } catch {
      // Ignorar quota/storage bloqueado para no romper la edición principal.
    }
  }

  removeDraft(key: string, storage: Storage = window.localStorage): void {
    removeProductFormDraft(key, storage);
  }
}
